var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartRed = function SvgHeartRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA1E28",
    d: "M22.5 8.813c0 6.562-9.73 11.874-10.145 12.093a.75.75 0 0 1-.71 0C11.23 20.686 1.5 15.375 1.5 8.813A5.82 5.82 0 0 1 7.313 3c1.935 0 3.63.833 4.687 2.24C13.057 3.832 14.752 3 16.688 3A5.82 5.82 0 0 1 22.5 8.813"
  })));
};
export default SvgHeartRed;